import { render, staticRenderFns } from "./AuthoritySetting.vue?vue&type=template&id=59045dfb&"
import script from "../../models/login-members/authority-setting.ts?vue&type=script&lang=ts&"
export * from "../../models/login-members/authority-setting.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports